import { NgModule } from '@angular/core';
import { Routes, RouterModule, Route } from '@angular/router';
import { DesktopLayoutComponent } from './core/components/desktop-layout/desktop-layout.component';
import { AuthGuard } from '@common/core/services/guards';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { SignInComponent } from '@core/components/sign-in/sign-in.component';
import { ERoles, EFsType, EResources } from './enums';
import { PingComponent } from './core/components/ping/ping.component';
import { SignInErrorComponent } from './core/components/sign-in-error/sign-in-error.component';
import { SignOutComponent } from './core/components/sign-out/sign-out.component';

const routes: Routes = [
  // { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
  {
    path: 'sign-in',
    component: SignInComponent,
  },
  {
    path: 'sign-out',
    component: SignOutComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'unauthorized',
    component: SignInErrorComponent,
  },
  {
    path: 'ping',
    component: PingComponent,
  },
  {
    path: '',
    component: DesktopLayoutComponent,
    children: [
      {
        path: 'changelog',
        loadChildren: () => import('./modules/changelog/changelog.module').then(m => m.ChangelogModule),
      },
      // {
      //   path: '',
      //   loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
      //   canActivate: [AuthGuard],
      //   data: {
      //     resources: [EResources.HOME],
      //   },
      // },
      {
        path: '',
        loadChildren: () => import('./modules/coupon/coupon.module').then(m => m.CouponModule),
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'documents',
      //   loadChildren: () => import('./modules/documents/documents.module').then(m => m.DocumentsModule),
      //   canActivate: [AuthGuard],
      //   data: {
      //     resources: [EResources.DOCUMENT_ARCHIVE],
      //   },
      // },
      // {
      //   path: 'settings',
      //   loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
      //   canActivate: [AuthGuard],
      //   data: {
      //     resources: [EResources.SETTINGS],
      //   },
      // },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
